import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { originalUrl: String, customerId: Number }

  connect() {
    this.startPolling();
  }

  disconnect() {
    this.stopPolling();
  }

  startPolling() {
    this.pollInterval = setInterval(() => {
      this.checkActivationStatus();
    }, 1000);
  }

  stopPolling() {
    clearInterval(this.pollInterval);
  }

  checkActivationStatus() {
    fetch(`/c/tableau/check_activations/perform?id=${this.customerIdValue}`)
    .then(response => response.json())
    .then(data => {
        if (data.status === 'completed') {
          console.log("Redirecting to URL:", this.originalUrlValue);
          this.stopPolling();
          window.location.href = this.originalUrlValue;
        } else if (data.status === 'failed') {
          this.stopPolling();
          this.showRetryButton();
        }
      })
      .catch(error => {
        console.error('Error checking activation status:', error);
        this.stopPolling();
        this.showRetryButton();
      });
  }

  retryActivation() {
    fetch(`/c/tableau/check_activations/retry_tableau_activation?id=${this.customerIdValue}`)
    .then(response => {
      if (response.ok) {
        window.location.href = this.originalUrlValue || '/fallback_path';
      } else {
        throw new Error('Activation retry failed');
      }
    })
    .catch(error => {
      console.error('Error retrying activation:', error);
      this.showRetryButton();
    });
  }

  showRetryButton() {
    const waitingTextElement = document.getElementById('tableau_activation_waiting_text');

    const buttonContainer = document.createElement('div');
    buttonContainer.style.marginTop = '10px';

    const retryButton = document.createElement('a');
    retryButton.textContent = 'Erneut versuchen';

    retryButton.addEventListener('click', () => {
      buttonContainer.innerHTML = ''; 
      this.retryActivation();
    });

    buttonContainer.appendChild(retryButton);
    waitingTextElement.parentNode.insertBefore(buttonContainer, waitingTextElement.nextSibling);
  }
}
